export const environment = {
  production: false,
  apiUrl: 'https://int-dev-driver.cordicgateway.net/DrvManWS?'
};
